import React, { memo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Button,
  Stack
} from 'investira.react.components';

const FeederMasterConfirmDelete = memo(props => {
  const { open, feeder, master, onClose, onRemove } = props;
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Excluir vínculo?</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          <Stack direction="column" gap={0.5} mb={1}>
            <span>
              Feeder: <b>{feeder?.pessoa || feeder?.pessoa_fantasia || 'Não encontrado'}</b>
            </span>
            <span>
              Master: <b>{master?.pessoa || master?.pessoa_fantasia || 'Não encontrado'}</b>
            </span>
          </Stack>
          Este vínculo será excluído permanentemente.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant={'contained'}
          onClick={() => {
            onClose();
            onRemove({
              pessoa_id: feeder?.pessoa_id,
              master_pessoa_id: master?.pessoa_id
            });
          }}
          autoFocus>
          Sim, excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default FeederMasterConfirmDelete;
